const config = {
  api: {
    domain: '//www.xj-storage.jp',
    path: '/public-list/GetList2.aspx',
    company: 'AS08576',
    output: 'json'
  },
  full: 1,
  icon: 1,
  pdf: 1,
  len: 5,
  doctypes: {
    all: {
      label: {
        ja: '全て',
        en: 'All'
      },
      ids: [],
      iconClass: ''
    },
    results: {
      label: {
        ja: '決算短信',
        en: 'Quarterly results'
      },
      ids: [1, 2, 3, 4, 16, 17, 18, 19, 20, 21],
      iconClass: '--ir-results',
    },
    disclosure: {
      label: {
        ja: '適時開示',
        en: 'Timely disclosure'
      },
      ids: [0, 5, 6, 8, 9, 13, 15, 24, 25, 28],
      iconClass: '--ir-disclosure',
    },
    legal: {
      label: {
        ja: '法定開示',
        en: 'Statutory disclosure'
      },
      ids: [1030, 1040, 1080, 1090, 1100, 1120, 1130, 1135, 1136, 1140, 1150, 1160, 1170, 1180, 1190, 1200, 1210, 1220, 1230, 1235, 1236, 1240, 1250, 1260, 1270, 1280, 1290, 1300, 1310, 1320, 1350, 1360],
      iconClass: '--ir-disclosure',
    },
    document: {
      label: {
        ja: 'IR資料',
        en: 'Document',
      },
      ids: [34, 90, 91, 92, 93, 95, 96, 97, 98, 101, 102, 103, 104, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 1900],
      iconClass: '--ir-document',
    },
    info: {
      label: {
        ja: 'お知らせ',
        en: 'Info',
      },
      ids: [14, 200],
      iconClass: '--ir-info',
    },
  }
};

export default config
